module.exports = __webpack_public_path__ + "img/SDN.e69f0c63.svg";